import { render, staticRenderFns } from "./resend-confirmation.vue?vue&type=template&id=9132f598&"
import script from "./resend-confirmation.vue?vue&type=script&lang=js&"
export * from "./resend-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./resend-confirmation.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/welearn-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9132f598', component.options)
    } else {
      api.reload('9132f598', component.options)
    }
    module.hot.accept("./resend-confirmation.vue?vue&type=template&id=9132f598&", function () {
      api.rerender('9132f598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/toasts/resend-confirmation.vue"
export default component.exports